export enum Fields {
    Email = 'email',
    Password = 'password',
    NewPassword = 'newpassword',
    RepeatPassword = 'repeatpassword',
    Login = 'login',
}

export type LoginInputs = {
    [Fields.Email]: string;
    [Fields.NewPassword]: string;
    [Fields.RepeatPassword]: string;
    [Fields.Password]: string;
};
